"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "ErrorPage", {
  enumerable: true,
  get: function () {
    return _ErrorPage.default;
  }
});
_Object$defineProperty(exports, "ErrorPageCancelDisabled", {
  enumerable: true,
  get: function () {
    return _ErrorPageCancelDisabled.default;
  }
});
var _ErrorPage = _interopRequireDefault(require("./ErrorPage"));
var _ErrorPageCancelDisabled = _interopRequireDefault(require("./ErrorPageCancelDisabled"));